import { downloadCSV } from 'react-admin';
import jsonExport from 'jsonexport/dist';
import { feesFieldConfigurations } from '../constants';

const OMITTED_FIELDS = ['id', '__typename'];

export const exportFeesData = (records: Record<string, any>[]) => {
  if (!records || records.length === 0) {
    return;
  }

  const columnMapping: Record<string, string> = feesFieldConfigurations.reduce<Record<string, string>>((acc, field) => {
    acc[field.source] = field.label || field.source;
    return acc;
  }, {});

  const formattedRecords = records.map((record) => {
    return Object.keys(record)
      .filter((key) => !OMITTED_FIELDS.includes(key))
      .reduce<Record<string, any>>((formattedRecord, key) => {
        const newKey = columnMapping[key] || key;
        formattedRecord[newKey] = record[key];
        return formattedRecord;
      }, {});
  });

  jsonExport(formattedRecords, (err, csv) => {
    if (err) {
      return;
    }
    downloadCSV(csv, 'fees');
  });
};
